module.exports = __webpack_public_path__ + "static/media/logo.d13a3dde.jpg";